import React,{ FC, PropsWithChildren } from "react";
import { useSignalRinvokeAction } from "./signalr-invoke-action";
import { useSignalR } from "@shesha-io/reactjs";


export const CustomConfigurableActionsAccessor: FC<PropsWithChildren<{}>> = ({ children }) => {

    const { connection } = useSignalR(false) ?? {};

    useSignalRinvokeAction(connection);

    return (
        <>{children}</>
    );
};